import Routes from '@/constants/routes'

export default {
  getRouteByName(name) {
    return Routes.find(route => route.name === name);
  }
};